import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteChallengeRequest = createAction('deleteChallengeRequest');
export const deleteChallengeSuccess = createAction<number>('deleteChallengeSuccess');
export const deleteChallengeFailure = createAction('deleteChallengeFailure');

export const deleteChallenge = (id: number) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(deleteChallengeRequest());
    try {
        await api.delete(`admin/challenges/${id}`);

        dispatch(deleteChallengeSuccess(id));
    } catch (e: any) {
        handleApiErrors(dispatch, deleteChallengeFailure, e);
    }
};
